// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  // banner: 'https://h1ktmf8p-3331.use2.devtunnels.ms/file/banner/',
  // uriLogo: 'https://h1ktmf8p-3331.use2.devtunnels.ms/file/parameter/',
  // catalogue: 'https://h1ktmf8p-3331.use2.devtunnels.ms/file/catalogue/',
  // url: 'https://h1ktmf8p-3331.use2.devtunnels.ms',

  // banner: 'http://italo:3331/file/banner/',
  // uriLogo: 'http://italo:3331/file/parameter/',
  // catalogue: 'http://italo:3331/file/catalogue/',
  // url: 'http://italo:3331',

  // banner: 'https://load.neuronweb.online/file/banner/',
  // uriLogo: 'https://load.neuronweb.online/file/parameter/',
  // catalogue: 'https://load.neuronweb.online/file/catalogue/',
  // url: 'https://load.neuronweb.online',

  // banner: 'https://api.energiaviva.lat/file/banner/',
  // uriLogo: 'https://api.energiaviva.lat/file/parameter/',
  // catalogue: 'https://api.energiaviva.lat/file/catalogue/',
  // url: 'https://api.energiaviva.lat',

  // banner: 'https://api.lettehelados.com/file/banner/',
  // uriLogo: 'https://api.lettehelados.com/file/parameter/',
  // catalogue: 'https://api.lettehelados.com/file/catalogue/',
  // url: 'https://api.lettehelados.com',

  // banner: 'https://api.firstmedcorp.us/file/banner/',
  // uriLogo: 'https://api.firstmedcorp.us/file/parameter/',
  // catalogue: 'https://api.firstmedcorp.us/file/catalogue/',
  // url: 'https://api.firstmedcorp.us',

  banner: 'https://api.corporacionaventura.com/file/banner/',
  uriLogo: 'https://api.corporacionaventura.com/file/parameter/',
  catalogue: 'https://api.corporacionaventura.com/file/catalogue/',
  url: 'https://api.corporacionaventura.com',

  defaultImg: './assets/defaultImg/defaultImage.png',
  ckConfig:
    'dialogui,dialog,a11yhelp,about,basicstyles,bidi,blockquote,clipboard,embedbase,' +
    'button,panelbutton,panel,floatpanel,colorbutton,colordialog,menu,' +
    'contextmenu,dialogadvtab,div,elementspath,enterkey,entities,popup,' +
    'filebrowser,find,fakeobjects,floatingspace,listblock,richcombo,' +
    'font,format,forms,horizontalrule,htmlwriter,iframe,indent,' +
    'indentblock,indentlist,justify,link,list,liststyle,magicline,' +
    'newpage,pagebreak,pastefromword,pastetext,preview,print,' +
    'removeformat,resize,save,menubutton,scayt,selectall,showblocks,' +
    'showborders,smiley,sourcearea,specialchar,stylescombo,tab,table,' +
    'tabletools,templates,toolbar,undo,wysiwygarea',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
